import React, { lazy, Suspense } from "react";
import "@fontsource/poppins";
import "./App.css";
import Navbar from './components/Navbar';
import MediaQuery from "react-responsive";
import { CookieSetting } from "cookiesetting-component";
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';



const Header = lazy(() => import("./components/Header"));
const Banner = lazy(() => import("./components/Banner/Banner"));
const Body = lazy(() => import("./components/Body/Body"));
const Keyfacts = lazy(() => import("./components/keyfacts/keyfacts"));
const Footer = lazy(() => import("./components/FooterNew"));
const Videosection = lazy(() => import("./components/Videosection/Videosection"));
const VideosectionMobile = lazy(() => import("./components/Videosection/VideosectionMobile"));
const Contact = lazy(() => import("./components/ContactUsForm/Contact"));


const App = () => {
  const appVersion = appversion.version;

  return (
    <CacheBuster
      currentVersion={appversion.version}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
      //If public assets are hosted somewhere other than root on your server.
      metaFileDirectory={process.env.PUBLIC_URL}
    >
      <CookieSetting
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
      <>
        <Suspense fallback={<div />}>
          <Navbar />
        </Suspense>
        <Suspense fallback={<div />}>
          <Banner />
        </Suspense>
        <Suspense fallback={<div />}>
          <Header />
        </Suspense>
        <Suspense fallback={<div />}>
          <Body />
        </Suspense>
        <Suspense fallback={<div />}>
          <Keyfacts />
        </Suspense>
        <MediaQuery minWidth={992}>
          <Suspense fallback={<div />}>
            <Videosection />
          </Suspense>
        </MediaQuery>
        <MediaQuery maxWidth={991}>
          <Suspense fallback={<div />}>
            <VideosectionMobile />
          </Suspense>
        </MediaQuery>
        <Suspense fallback={<div />}>
          <Contact />
        </Suspense>
        <Suspense fallback={<div />}>
          <Footer />
        </Suspense>

      </>
    </CacheBuster>

  );
}

export default App;
